var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationTriangleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "exclamation-triangle-fill",
    clipPath: "url(#clip0_2120_94541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.973 2.34917C13.8245 2.09052 13.6104 1.87562 13.3523 1.72618C13.0942 1.57674 12.8012 1.49805 12.503 1.49805C12.2047 1.49805 11.9118 1.57674 11.6537 1.72618C11.3956 1.87562 11.1815 2.09052 11.033 2.34917L0.74748 19.8497C0.0619799 21.0167 0.88398 22.5002 2.21748 22.5002H22.787C24.1205 22.5002 24.944 21.0152 24.257 19.8497L13.973 2.34917ZM12.5 7.50017C13.3025 7.50017 13.931 8.19317 13.85 8.99267L13.325 14.2532C13.3073 14.4598 13.2128 14.6523 13.06 14.7926C12.9072 14.9329 12.7074 15.0108 12.5 15.0108C12.2926 15.0108 12.0927 14.9329 11.9399 14.7926C11.7872 14.6523 11.6926 14.4598 11.675 14.2532L11.15 8.99267C11.1311 8.80402 11.152 8.61351 11.2112 8.43342C11.2705 8.25333 11.3668 8.08764 11.494 7.94704C11.6212 7.80643 11.7764 7.69403 11.9497 7.61706C12.1229 7.5401 12.3104 7.50028 12.5 7.50017ZM12.503 16.5002C12.9008 16.5002 13.2823 16.6582 13.5636 16.9395C13.8449 17.2208 14.003 17.6023 14.003 18.0002C14.003 18.398 13.8449 18.7795 13.5636 19.0608C13.2823 19.3421 12.9008 19.5002 12.503 19.5002C12.1052 19.5002 11.7236 19.3421 11.4423 19.0608C11.161 18.7795 11.003 18.398 11.003 18.0002C11.003 17.6023 11.161 17.2208 11.4423 16.9395C11.7236 16.6582 12.1052 16.5002 12.503 16.5002Z",
    fill: "#FD0523"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2120_94541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationTriangleFill);
export default __webpack_public_path__ + "static/media/exclamation-triangle-fill.caa58a2c7a243419198f7c60869cbe7b.svg";
export { ForwardRef as ReactComponent };